module.exports = __webpack_public_path__ + "img/avatar3.d70ed84a.png";